import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { expandCollapse } from '../animations/app-animations';

export enum BannerPropertyKey {
  Id = 'id',
  OfferGroup = 'offer_group',
  Status = 'is_active',
  Condition = 'condition',
  Survey = 'survey',
  LastModified = 'updated',
}

export interface BannerProperty {
  key: BannerPropertyKey;
  label: string;
  value: string | number;
  route?: (string | number)[];
}

@Component({
  selector: 'page-banner',
  templateUrl: './page-banner.component.html',
  styleUrls: ['./page-banner.component.scss'],
  animations: [expandCollapse],
})
export class PageBannerComponent implements OnInit {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() description: string = '';
  @Input() showAddButton: boolean = false;
  @Input() properties: BannerProperty[] = [];
  @Input() buttonTitle: string = '';
  @Input() publishButton: boolean = false;
  @Input() isPublishing: boolean = false;
  @Input() isAdminOnly: boolean = false;
  @Input() collapsibleSubtitle: boolean = false;

  isExpanded: boolean = false;
  isSubtitleExpanded: boolean = true;

  propertyKeys = BannerPropertyKey;

  @Output() addNewEvent = new EventEmitter<void>();
  @Output() publishEvent = new EventEmitter<void>();

  constructor(protected router: Router) {}

  ngOnInit() {
    if (this.collapsibleSubtitle) { 
      this.isSubtitleExpanded = false;
    }
  }

  navigateToRoute(prop: BannerProperty) {
    if (this.isSurvey(prop)) {
      this.router.navigate(prop.route);
    } else if (this.isOffer(prop)) {
      this.router.navigate(prop.route);
    }
  }

  isStatusActive(property: BannerProperty): boolean {
    return property.value === 'Active';
  }

  isSurvey(property: BannerProperty): boolean {
    return property.key === BannerPropertyKey.Survey && property.route && property.route.length > 0;
  }

  isOffer(property: BannerProperty): boolean {
    return property.key === BannerPropertyKey.OfferGroup && property.route && property.route.length > 0;
  }

  get shouldMinimizeWidth(): boolean {
    return this.subtitle && this.subtitle.length > 170;
  }
}
